import React from 'react';
import { Alert } from 'antd';
import { unfilledPlaceholders } from './placeholderFill';

export function PlaceholderWarning({ text }) {
  const remaining = unfilledPlaceholders(text);
  return remaining.length ? <Alert showIcon type="warning" style={{ fontSize: 12, flexShrink: 0 }}
    message={`Not filled: ${remaining.map(key => `{{${key}}}`).join(', ')}. You can edit these or still send.`} /> : null;
}
